var _circle, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartnerWithGrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000007337"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 170",
    opacity: 0.5,
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#DBBEFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2599_23301",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 7,
    width: 25,
    height: 25
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipPath155"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path153",
    d: "M8.75 7.5H32.5V31.25H8.75V7.5Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2599_23301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path159",
    d: "M8.75 19.375C18.1126 19.375 26.106 15.2037 31.5512 8.41103",
    stroke: "#B246FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "path163",
    d: "M9.67798 22.8877C10.9279 22.8535 12.1664 22.7504 13.3889 22.5805V30.3223H9.67798V22.8877Z",
    stroke: "#B246FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "path167",
    d: "M16.9141 21.8481C18.1764 21.5234 19.4152 21.1255 20.625 20.6571V30.3223H16.9141V21.8481Z",
    stroke: "#B246FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "path171",
    d: "M24.3359 18.9498C25.6195 18.2604 26.8591 17.4854 28.0469 16.6287V30.3223H24.3359V18.9498Z",
    stroke: "#B246FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "path175",
    d: "M31.572 12.1377V8.42676H27.8611",
    stroke: "#B246FF",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerWithGrow);
export default __webpack_public_path__ + "static/media/partner-with-grow.68495287c78eee80691438ec1a432e70.svg";
export { ForwardRef as ReactComponent };